import {
    FormLanguageProvider,
    LocalizedFormInputFields,
    LocalizedFormTextareaFields,
    SchemaFormDefinition,
} from '@mews-commander/form';
import { ContentSection } from '@mews-commander/ui';
import { FormCounterField, lt } from '@mews/framework';
import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { useCommanderSelector } from '@mews-commander/utils';
import { getSortedLanguages } from '@mews-commander/legacy-entities/src/ducks/languages';
import { useProductCategoryOptions } from '../../queries/useProductCategoryOptions';
import { useProductCategoryFormSchema } from '../schemas/productCategoryFormSchema';
import { ProductCategoryDropzoneField } from '../fields/ProductCategoryDropzoneField';

export const useProductCategoryFormDefinition = (
    imageId?: string | null,
    updatedProductCategoryId?: string | null
): SchemaFormDefinition<ReturnType<typeof useProductCategoryFormSchema>> => {
    const { defaultLanguageCode } = useCurrentEnterprise();
    const languages = useCommanderSelector(getSortedLanguages);
    const productCategoryOptions = useProductCategoryOptions(updatedProductCategoryId);

    return {
        fields: {
            parentProductCategoryId: {
                label: lt('ParentCategory'),
                field: {
                    type: 'select',
                    options: productCategoryOptions,
                },
            },
            names: {
                label: lt('Name'),
                render: (props) => <LocalizedFormInputFields {...props} autoFocus />,
            },
            shortNames: {
                label: lt('ShortName'),
                render: (props) => <LocalizedFormInputFields {...props} />,
            },
            descriptions: {
                label: lt('Description'),
                render: (props) => <LocalizedFormTextareaFields {...props} />,
            },
            ordering: {
                label: lt('Ordering'),
                render: (props) => <FormCounterField {...props} helper={lt('OrderingHint')} />,
            },
            image: {
                label: lt('Image'),
                render: (props) => <ProductCategoryDropzoneField {...props} imageId={imageId} />,
            },
        },
        renderFields: (fields) => (
            <FormLanguageProvider defaultLanguageCode={defaultLanguageCode} languages={languages}>
                <ContentSection title={lt('DetailPlural')} spacing="300" contentSpacing="200">
                    {fields.parentProductCategoryId}
                    {fields.names}
                    {fields.shortNames}
                    {fields.descriptions}
                    {fields.ordering}
                    {fields.image}
                </ContentSection>
            </FormLanguageProvider>
        ),
    };
};
